module.exports = [{"title":"Installation","items":[{"id":"getting-started","title":"Getting Started"}]},{"title":"Reference","items":[{"id":"components","title":"Components"},{"id":"props","title":"Props"},{"id":"data-api","title":"Data API"},{"id":"state-management","title":"State Management"},{"id":"pub-sub","title":"Pub/Sub Emitter"}]},{"title":"Customization","items":[{"id":"override-components","title":"Override Components"},{"id":"custom-components","title":"Custom Components"},{"id":"root-components","title":"Root Components"}]}]


//////////////////
// WEBPACK FOOTER
// ./content/docs/nav.yml
// module id = 117
// module chunks = 114276838955818 236594062348235